var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('BaseInventory',{attrs:{"categoryId":"8","categoryName":"Protector","categorySectionIcon":"fa-wrench","useSearch1":true,"search1Title":"Series"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }